import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MostUsedModule } from '@shared/components/most-used/most-used.module';
// eslint-disable-next-line max-len
import { MultipleSelectWithSearchComponent } from '@shared/components/search/multiple-select-with-search/multiple-select-with-search.component';
import { TinyKitModule } from '@shared/components/tiny-kit/tiny-kit.module';
import { SharedPipesModule } from '@shared/pipes/shared-pipes/shared-pipes.module';
import { TranslateUsersModule } from '@shared/pipes/translate-users/translate-users.module';
import { NgxOutsideClickModule } from 'ngx-outside-click';
import { SearchFieldComponent } from './search-field/search-field.component';
import { SearchInputComponent } from './search-input/search-input.component';
import { TestControlComponent } from './test-control/test-control.component';
import { SearchTextFieldComponent } from './search-text-field/search-text-field.component';
import { MultipleSelectBaseComponent } from './multiple-select-base/multiple-select-base.component';

@NgModule({
  declarations: [
    SearchFieldComponent,
    SearchInputComponent,
    TestControlComponent,
    MultipleSelectWithSearchComponent,
    SearchTextFieldComponent,
    MultipleSelectBaseComponent,
  ],
  exports: [ SearchFieldComponent,
             SearchInputComponent,
             TestControlComponent,
             SearchTextFieldComponent,
             MultipleSelectWithSearchComponent, MultipleSelectBaseComponent
  ],
  imports: [
    CommonModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatIconModule,
    MatAutocompleteModule,
    MatInputModule,
    MostUsedModule,
    MatCheckboxModule,
    FormsModule,
    MatMenuModule,
    NgxOutsideClickModule,
    SharedPipesModule,
    TinyKitModule,
    OverlayModule,
    TranslateUsersModule
  ],
})
export class SearchModule {}
